import React from "react";

import { Button, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useGetRecaptchaQuery, useVerifyRecaptchaMutation } from "store/api";

import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "components/Common/InputField";
import { ErrorAlert } from "components/Common";

const Recaptcha: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = React.useState<string | null>(null);

  const [verifyRecaptcha, { isLoading }] = useVerifyRecaptchaMutation();

  const { data, refetch } = useGetRecaptchaQuery("");

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <div>
          <h1 className="text-2xl font-bold mb-4">
            Please verify you're not a robot
          </h1>
          <p className="mb-4">
            You may have tried logging in too many times. Complete the CAPTCHA
            below to continue.
          </p>
        </div>

        <Formik
          validateOnBlur
          enableReinitialize
          initialValues={{
            id: data?.id,
            input: "",
          }}
          validationSchema={Yup.object().shape({
            input: Yup.string().required("Text is required"),
          })}
          onSubmit={async (values) => {
            try {
              await verifyRecaptcha(values).unwrap();
              notification.success({
                message: "",
                description: "Verification has been successfully",
              });
              navigate("/account-lock");
            } catch (error: any) {
              setError(error?.data?.error || error?.data?.message);
              refetch();
            }
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert type="error" message={error} setMessage={setError} />
              <div className="flex items-center">
                <div dangerouslySetInnerHTML={{ __html: data?.image }} />
                <InputField
                  label="Type the characters you see here"
                  name="input"
                  type="text"
                  placeholder="Enter characters"
                />
              </div>

              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isLoading}
                disabled={!isValid || !dirty || isLoading}
              >
                Continue
              </Button>
              <div className="flex items-center justify-end p-3 gap-2">
                <Link to="/" className="text-blue-500">
                  Back to login
                </Link>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Recaptcha;
